import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SptAudioService} from '@spout/web-global/data-access';

@Component({
  selector: 'spt-help-compressor-content',
  templateUrl: './help-compressor-content.component.html',
  styleUrls: ['./help-compressor-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpCompressorContentComponent {
  constructor(private sptAudioService: SptAudioService) {}
  refresh(): void {
    this.sptAudioService.refreshAudioDeviceList().subscribe(() => {});
  }
}
